import * as React from 'react';
import moment from 'moment';

import { isStringEmpty } from './Micro';
import Checkbox from '@Primitive/Checkbox';
// ------------------------------------------------------------------------------------------------
export const enum Currency {
    USD = 0,
    GBP = 1,
    Euro = 2,
    ZAR = 3,
}

export const enum SelectAllMode {
    All = 0,
    Filtered = 1,
}
// ------------------------------------------------------------------------------------------------
export namespace FormattersUI {
    // --------------------------------------------------------------------------------------------
    export function price(value: any, currency: Currency): string | React.ReactElement<any> {
        // Set the appropriate price from currency.
        switch (currency) {
            case Currency.USD: return <div><i style={{ verticalAlign: 'text-top' }} className="fas fa-dollar-sign"></i>{parseFloat(value)}</div>;
            case Currency.GBP: return <div><i style={{ verticalAlign: 'text-top' }} className="fas fa-pound-sign"></i>{parseFloat(value)} </div>;
            case Currency.Euro: return <div><i style={{ verticalAlign: 'text-top' }} className="fas fa-euro-sign"></i>{parseFloat(value)}</div>;
            case Currency.ZAR: return <div><i style={{ paddingRight: 5, fontWeight: "bolder" }}>R</i>{parseFloat(value)}</div>;
            default:
                return value;
        }
    }
    // --------------------------------------------------------------------------------------------
    export function currencyIcon(currency: Currency): string | React.ReactElement<any> {
        // Set the appropriate price from currency.
        switch (currency) {
            case Currency.USD: return <i style={{ verticalAlign: 'text-top' }} className="fas fa-dollar-sign"></i>;
            case Currency.GBP: return <i style={{ verticalAlign: 'text-top' }} className="fas fa-pound-sign"></i>;
            case Currency.Euro: return <i style={{ verticalAlign: 'text-top' }} className="fas fa-euro-sign"></i>;
            case Currency.ZAR: return <i style={{ paddingRight: 5, fontWeight: "bolder" }}>R</i>;
            default:
                return null;
        }
    }
    // --------------------------------------------------------------------------------------------
    export function boolean(value: any) {
        try {
            return <Checkbox
                value={value}
                style={{
                    margin: "0px auto",
                    color: "rgb(0, 188, 212)"
                }}
            />
        } catch {
            return value;
        }
    }
    // --------------------------------------------------------------------------------------------
    export function color(value: any) {
        try {
            return <div
                style={{
                    padding: 5,
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0, 0, 0, .1)',
                    display: 'inline-block',
                    cursor: 'pointer'
                }}
            >
                <div style={{
                    width: 36,
                    height: 14,
                    borderRadius: 2,
                    background: value
                }} />
            </div>
        } catch {
            return value;
        }
    }
    // --------------------------------------------------------------------------------------------
    export function duration(value: string): string {
        return !isStringEmpty(value) ?
            `${moment.duration(value).format({ template: 'd[d] h:mm:ss', trim: false })}` : '';
    }
    // ------------------------------------------------------------------------------------------------
}
// ------------------------------------------------------------------------------------------------